import { render, staticRenderFns } from "./PostComponent.vue?vue&type=template&id=a68164e0&"
import script from "./PostComponent.vue?vue&type=script&lang=js&"
export * from "./PostComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports